import { Row } from 'antd';
import { useTranslation } from 'react-i18next';

import { DocumentDetailsModel } from 'api/documents/documents.model';
import { CopyBlockchainAddressActionLink } from 'components/ActionLinks';
import { ToggleFavouriteButton } from 'components/Buttons';
import ProgressSquares from 'components/ProgressSquares';
import { CertificateDetailsModel } from 'models/certificate.model';

import * as Styled from './Header.styles';

const Header = ({
  title,
  documentBlockchainAddress,
  jobId,
  favourite,
  additionalDetails,
}: DocumentDetailsModel<CertificateDetailsModel>) => {
  const { t } = useTranslation();

  return (
    <Styled.HeaderWrapper>
      <Styled.Title>{title}</Styled.Title>

      <Styled.HeaderActions justify="space-between">
        <CopyBlockchainAddressActionLink blockchainAddress={documentBlockchainAddress} />
        <Styled.Buttons>
          <ToggleFavouriteButton hasDarkOutline isClickable jobId={jobId} isFavourite={favourite}>
            {favourite ? t('certificate.removeFromFavourites') : t('certificate.addToFavourites')}
          </ToggleFavouriteButton>
        </Styled.Buttons>
        <Styled.Divider />
      </Styled.HeaderActions>

      <Row justify="space-between">
        <Styled.Overall>{t('certificate.overall')}</Styled.Overall>
        <ProgressSquares progress={additionalDetails?.percentRecycled ?? 0} />
      </Row>
    </Styled.HeaderWrapper>
  );
};

export default Header;
